import React, { Component, PropTypes } from 'react';
import { StyledSelectBox } from './styles';

class SelectBox extends Component {
  static propTypes = {
    label: PropTypes.string,
    removeLabel: PropTypes.bool,
    items: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    textKey: PropTypes.string.isRequired,
    valueKey: PropTypes.string.isRequired,
    className: React.PropTypes.string,
    disabled: PropTypes.bool
  };
  static defaultProps = {
    value: 'N/A',
    label: '',
    removeLabel: false,
    className: '',
    disabled: false
  };
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
    const { onSelect } = this.props;
    onSelect(event.target.value);
  }
  render() {
    const { value, label, items, textKey, valueKey, removeLabel, className, disabled } = this.props;
    const ensureItems = items || [];
    return ( //eslint-disable-next-line
      <StyledSelectBox className={className} value={value} onChange={this.handleChange} disabled={disabled}>
        <option value="N/A" aria-hidden={removeLabel} disabled>{label}</option>
        {ensureItems.map(item => (
          <option key={item[valueKey]} value={item[valueKey]}>{item[textKey]}</option>
        ))}
      </StyledSelectBox>
    )
  }
}

export default SelectBox;



/** WEBPACK FOOTER **
 ** ./src/components/SelectBox/index.js
 **/